<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "BaseGuide"
}
</script>

<style scoped>

</style>